<template>
    <div v-if="confirmShowBox" class="confirm-your-email-box">
      <div class="close-icon" @click="confirmHideBox">
        <i class='bx bx-x'></i>
      </div>
      <div class="text-1">
        <p><b>Confirm your email</b> to access our link building services and boost visibility.<br> If you haven't received the email, request a re-send.</p>
      </div>
      <div class="btn-box">
        <router-link to="/" class="btn-1" @click="resendEmail">Resend Confirmation Email</router-link>
      </div>
   
    </div>
  </template>
  
  <script>
  import { useToast } from "vue-toastification";
  const toast = useToast();

  export default {
    components: {},
    mounted() {
      this.checkUrlParams();
      if (this.userData.emailVerified) {
        this.confirmShowBox = false;
      }else{
        this.confirmShowBox = true;
      }
    },
    data() {
      return {
        confirmShowBox: false,
        resendEmailData: {
          email: "",
          utm_source: "direct",
          utm_medium: "direct",
          utm_campaign: "direct",
          da: "",
          category: "",
        },
        data: {
          verification_code: ''
        }
      };
    },
    methods: {
      getQueryParameterValue(parameterName) {
        var fromRoute = this.$route?.query?.[parameterName];
        if (fromRoute != null && fromRoute !== "") {
          return Array.isArray(fromRoute) ? fromRoute[0] : String(fromRoute);
        }
        var queryString = location.search.substring(1);
        var queryParams = queryString.split("&");

        for (var i = 0; i < queryParams.length; i++) {
          var eq = queryParams[i].indexOf("=");
          var key = eq === -1 ? queryParams[i] : queryParams[i].substring(0, eq);
          if (key === parameterName) {
            var raw = eq === -1 ? "" : queryParams[i].substring(eq + 1);
            return decodeURIComponent(raw);
          }
        }
        return null;
      },
      checkUrlParams() {
        var daValue = this.getQueryParameterValue("da");
        var categoryValue = this.getQueryParameterValue("category");
        var sourceValue = this.getQueryParameterValue("utm_source");
        var mediumValue = this.getQueryParameterValue("utm_medium");
        var campaignValue = this.getQueryParameterValue("utm_campaign");
        var webOrder = this.getQueryParameterValue("order");
        var mediaLinksData = this.getQueryParameterValue("media_links_data");
        var brandMentionsData = this.getQueryParameterValue("brand_mentions_data");

        if (daValue !== null && categoryValue !== null) {
          this.resendEmailData.da = daValue;
          this.resendEmailData.category = categoryValue;
          this.queryParamValue = `?da=${daValue}&category=${categoryValue}`;
          if(sourceValue){
            this.resendEmailData.utm_source = sourceValue;
            this.queryParamValue += `&utm_source=${sourceValue}`;
          }
          if(mediumValue){
            this.resendEmailData.utm_medium = mediumValue;
            this.queryParamValue += `&utm_medium=${mediumValue}`;
          }
          if(campaignValue){
            this.resendEmailData.utm_campaign = campaignValue;
            this.queryParamValue += `&utm_campaign=${campaignValue}`;
          }
          this.queryParam = true;
        }

        if (sourceValue) {
          this.resendEmailData.utm_source = sourceValue;
        }
        if (mediumValue) {
          this.resendEmailData.utm_medium = mediumValue;
        }
        if (campaignValue) {
          this.resendEmailData.utm_campaign = campaignValue;
        }
        if (webOrder) {
          this.resendEmailData.order = webOrder;
        }
        if (mediaLinksData) {
          this.resendEmailData.media_links_data = mediaLinksData;
        }
        if (brandMentionsData) {
          this.resendEmailData.brand_mentions_data = brandMentionsData;
        }

        if(this.$route.query.verification_code){
          this.data.verification_code = this.$route.query.verification_code;
          this.verification();
        }
      },
      postVerifyRedirect() {
        const query = { ...(this.$route.query || {}) };
        delete query.verification_code;
        if (query.brand_mentions_data) {
          return { path: "/brand-mentions", query };
        }
        if (query.media_links_data) {
          return { path: "/media-links-summary", query };
        }
        if (query.order) {
          return { path: "/product", query };
        }
        return { path: "/dashboard", query };
      },
      confirmHideBox() {
        this.confirmShowBox = false;
      },
      async verification() {
        console.log(this.$store.getters["Auth/getUser"]);
        this.$parent.loading = true;
        try {
          let res = await this.$store.dispatch(
            "Auth/isEmailVerifiedAction",
            {
              'verification_code' : this.data.verification_code
            },
            {
              root: true,
            }
          );
          if(res.success){
            this.confirmShowBox = false;
          }
          this.$parent.loading = false;
          this.$router.replace(this.postVerifyRedirect());
          toast.success(res.message, { timeout: 3000 });
          console.log(this.$store.getters["Auth/getUser"]);
        } catch (error) {
            this.$parent.loading = false;
            toast.error(error.response.data.errors, { timeout: 3000 });
            this.errors = error.response.data.errors;
        }
      },
      async resendEmail() {
        this.resendEmailData.email = this.userData.email;
        if(this.resendEmailData.email){
          try {
            this.loading = true;
            let res = await this.$store.dispatch(
              "Auth/resendEmailForVerificationAction", this.resendEmailData, {
                root: true,
              }
            );

            if (res.success) {
              this.loading = false;
              toast.success(res.message, { timeout: 3000 });
            }
          } catch (error) {
            this.loading = false;
            toast.error(error.response.data.errors, { timeout: 3000 });
            this.errors = error.response.data.errors;
          }
        }
      },
    },
    computed: {
      userData() {
        const data = this.$store.getters["Auth/getUser"];
        return {
          email: data.email,
          emailVerified: data.is_email_verified,
        };
      },
    },
    watch: {
      userData(newVal) {
        if (newVal.emailVerified) {
          this.confirmShowBox = false;
        }else{
          this.confirmShowBox = true;
        }
      }
    }
  };
  </script>
  